import { render, staticRenderFns } from "./EditFooter.vue?vue&type=template&id=56a2e985&scoped=true&"
import script from "./EditFooter.vue?vue&type=script&lang=js&"
export * from "./EditFooter.vue?vue&type=script&lang=js&"
import style0 from "./EditFooter.vue?vue&type=style&index=0&id=56a2e985&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a2e985",
  null
  
)

export default component.exports